import styled from 'styled-components';

import { Z_INDEX_POPOVER } from '@savgroup-front-common/constants';

export const $FullScreenLoader = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: ${Z_INDEX_POPOVER};
  background-color: ${({ theme }) => theme.colors.white};
  top: 0;
`;
